import React from 'react';
import { InfoIcon, v2 } from '@fieldnation/platform-components';

import styles from './styles.scss';
import { PartsProviderInputsValue } from './types.d';

const { Checkbox, TextInput } = v2;

interface Props {
  value: PartsProviderInputsValue;
  onChange: (value: PartsProviderInputsValue) => void;
}

const PartsProviderInputs = ({ value, onChange }: Props): JSX.Element => {
  const toggle = (key: 'rmaNumber' | 'serialNumber' | 'internalNumber') => (selected) => {
    onChange({
      ...value,
      [key]: selected?.includes?.(key) ?? false,
    });
  };

  return (
    <div className={styles['provider-inputs']}>
      <p className={styles['provider-inputs-header']}>Provider inputs</p>
      <p className={styles['provider-inputs-description']}>
        Define what the provider is required to submit.
      </p>
      <Checkbox
        id="rmaNumber"
        options={[{ label: 'RMA number', value: 'rmaNumber' }]}
        value={value.rmaNumber ? ['rmaNumber'] : []}
        onChange={toggle('rmaNumber')}
      />
      <Checkbox
        id="serialNumber"
        options={[{ label: 'serial number', value: 'serialNumber' }]}
        value={value.serialNumber ? ['serialNumber'] : []}
        onChange={toggle('serialNumber')}
      />
      <div className={styles['provider-inputs-option']}>
        <Checkbox
          id="internalNumber"
          options={[{ label: 'internal number', value: 'internalNumber' }]}
          value={value.internalNumber ? ['internalNumber'] : []}
          onChange={toggle('internalNumber')}
        />
        <InfoIcon>
          A number used internally by your organization to identify the part, such as an asset tag.
        </InfoIcon>
      </div>
      {value.internalNumber && (
        <div className={styles['alias-input']}>
          <TextInput
            id="internalNumberAlias"
            label="Internal number alias"
            helpText="e.g. Asset tag"
            optional
            value={value.internalNumberAlias}
            onChange={(e) => onChange({
              ...value,
              internalNumberAlias: e.target.value,
            })}
          />
        </div>
      )}
    </div>
  );
};

export default PartsProviderInputs;
